import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { addOpacity } from './helpers';

const PREFIX = 'EmptyState';

const classes = {
    header: `${PREFIX}header`,
    paragraph: `${PREFIX}paragraph`
};

const StyledBox = styled(Box)(({ theme }) => ({
    [`& .${classes.header}`]: {
        color: theme.palette.titleTextColour
    },

    [`& .${classes.paragraph}`]: {
        marginTop: theme.spacing(0.5),
        color: addOpacity(theme.palette.text.primary, 0.5)
    }
}));

interface EmptyStateProps {
    headerText: string;
    paragraphText: string;
    actions?: React.ReactNode;
}

export const EmptyState: React.FC<React.PropsWithChildren<EmptyStateProps>> = props => {
    const { headerText, paragraphText, children, actions } = props;
    return (
        <StyledBox
            display="flex"
            flexDirection="column"
            flex={1}
            justifyContent="center"
            alignItems="center"
            padding={2}
        >
            {children}
            <Typography align="center" variant="h5" className={classes.header}>
                {headerText}
            </Typography>
            <Typography align="center" variant="h6" color="textSecondary" className={classes.paragraph}>
                {paragraphText}
            </Typography>
            {actions && <Box mt={2}>{actions}</Box>}
        </StyledBox>
    );
};
